import React, { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTranslation } from 'react-i18next';
import './Blog.css';

function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user, isAdmin } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    const fetchPosts = async () => {
      const { data, error } = await supabase
        .from('blog_posts')
        .select('id, title, summary, slug, created_at, thumbnail')
        .order('created_at', { ascending: false });

      if (error) {
        console.error('Error fetching posts:', error);
      } else {
        setPosts(data);
      }
      setLoading(false);
    };

    fetchPosts();
  }, [isAdmin]);

  const handleDelete = async (id, title) => {
    if (window.confirm(`"${title}" 포스트를 정말 삭제하시겠습니까?`)) {
      const { error } = await supabase.from('blog_posts').delete().eq('id', id);
      if (error) {
        alert('삭제 중 오류가 발생했습니다.');
      } else {
        setPosts(posts.filter((post) => post.id !== id));
      }
    }
  };

  return (
    <div className="blog-container">
      <div className="blog-header">
        <h2 className="blog-title">{t('home.insightTitle')}</h2>

        {isAdmin && (
          <button className="write-post-btn" onClick={() => navigate('/blog/new')}>
            글 작성
          </button>
        )}
      </div>

      {loading ? (
        <p>로딩 중...</p>
      ) : posts.length === 0 ? (
        <p>작성된 글이 없습니다.</p>
      ) : (
        <ul className="blog-list">
          {posts.map((post) => (
            <li key={post.id} className="blog-item">
              <Link to={`/blog/${post.slug}`} className="blog-link">
                <div className="blog-text-content">
                  <h3>{post.title}</h3>
                  <p className="blog-summary">{post.summary}</p>
                  <span className="blog-date">
                    {new Date(post.created_at).toLocaleDateString()}
                  </span>
                </div>
                <img
                  src={post.thumbnail || '/butterfly.png'}
                  alt="썸네일"
                  className="blog-thumbnail"
                />
              </Link>
              {isAdmin && (
                <div className="admin-post-controls">
                  <button
                    className="edit-post-btn"
                    onClick={() => navigate(`/blog/edit/${post.slug}`)}
                  >
                    수정
                  </button>
                  <button
                    className="delete-post-btn"
                    onClick={() => handleDelete(post.id, post.title)}
                  >
                    삭제
                  </button>
                </div>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default Blog;
